let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ayf3G")).then(() => parcelRequire('3nfCl'));